export const rolesObject = [
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "SU Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "SU Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "business-owner",
            "description": "Business Owner",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "privileges-list",
            "description": "Privileges",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "role-list",
            "description": "Role List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "change-password",
            "description": "Change Password",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "employee-hierarchy",
            "description": "Employee Hierarchy",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "User Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "User Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "users-list",
            "description": "Users",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },

          {
            "seqNo": 3,
            "name": "change-password",
            "description": "Change Password",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "create-user",
            "description": "User Communication",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },

          {
            "seqNo": 6,
            "name": "employee-hierarchy",
            "description": "Employee Hierarchy",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Offer Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Offer Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "offer-list",
            "description": "Offers",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Dynamic Schedule",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Dynamic Schedule",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "dynamic-schedule-list",
            "description": "Dynamic Schedule List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Company News Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Company News Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "company-news",
            "description": "Company News",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Inventory Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Inventory Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "product",
            "description": "Products",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "vendor-list",
            "description": "Vendors",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "vendor-request",
            "description": "Vendor Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "vendor-approve-list",
            "description": "Approved Vendors",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "vendor-block-list",
            "description": "Blocked List Vendors",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "branch",
            "description": "Branch Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "material-purchases",
            "description": "Material Purchases",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "material-transfer",
            "description": "Material Transfer",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "material-issues",
            "description": "Material Issue",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 10,
            "name": "material-to-be-issued",
            "description": "Material To Be Issued",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 11,
            "name": "material-issued-list",
            "description": "Material Issued List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 12,
            "name": "material-requests",
            "description": "Material Issue-Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 13,
            "name": "productstock",
            "description": "Product Stock Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 14,
            "name": "latest-product-stock",
            "description": "Product Stock",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 15,
            "name": "product-opening-balance",
            "description": "Product Opening Balance",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 16,
            "name": "product-composition",
            "description": "Product Composition",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Master Data Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Master Data Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "ticket-types",
            "description": "Ticket Types",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "ticket-sub-types",
            "description": "Ticket Sub-types",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "params",
            "description": "Params List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "params-update",
            "description": "Users Param Update",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "task-master",
            "description": "Task Master",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "customer-params",
            "description": "Customer Params",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "route-list",
            "description": "Routes",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "plan-definition",
            "description": "Plans",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "customer-APK",
            "description": "Customer APK Version",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 10,
            "name": "status-info",
            "description": "Status Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 11,
            "name": "services",
            "description": "Services",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 12,
            "name": "uom-conversion-list",
            "description": "Uom Conversions",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 13,
            "name": "tax-master-list",
            "description": "Tax Definitions",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 14,
            "name": "product-master-group-list",
            "description": "Product Groups",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 15,
            "name": "list-location",
            "description": "Locations",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 16,
            "name": "department",
            "description": "Departments",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 17,
            "name": "employee",
            "description": "Employee List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 18,
            "name": "designation",
            "description": "Designations",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 19,
            "name": "employee-type",
            "description": "Employee Types",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 20,
            "name": "customer-product-price-list",
            "description": "Customer Product Prices",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 21,
            "name": "billing-term-list",
            "description": "Billing Terms",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 22,
            "name": "payment-term-list",
            "description": "Payment Terms",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 23,
            "name": "object-category",
            "description": "Asset Category",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 24,
            "name": "asset-deprciation",
            "description": "Asset Deprciation Methods",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 25,
            "name": "object-group",
            "description": "Asset Group",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 26,
            "name": "object-type",
            "description": "Asset Type",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 27,
            "name": "uom",
            "description": "Uom",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 28,
            "name": "asset-status",
            "description": "Asset Status",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 29,
            "name": "branch",
            "description": "Branch",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Notification Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Notification Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "notification",
            "description": "Notifications",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Plan Info Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Plan Info Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-plan-group",
            "description": "Plan Groups",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "plan-definition",
            "description": "Plans",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Ticket Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Ticket Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "ticketPostedByMe",
            "description": "Ticket Posted By Me",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "ticketlist",
            "description": "Tickets",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "ticket-prioritytime-list",
            "description": "Ticket Priority Times",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "ticket-list",
            "description": "Tickets",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Task Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Task Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "tasklist",
            "description": "Tasks",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "task-filter",
            "description": "Task Filter",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "user-task-filter",
            "description": "User Tasks",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "my-tasks",
            "description": "My Tasks",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "taskPostedByMe",
            "description": "Task Posted By Me",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "all-task-status-wise",
            "description": "Task Status Wise",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "update-taskpriority-time",
            "description": "Task Priority Times",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Marketing Data",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Marketing Data",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "marketing-data",
            "description": "Marketing Data",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "marketing-data-filter",
            "description": "Marketing Data Filter",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "marketing-data-filter-by-user",
            "description": "Marketing Data Filter By User",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "LMO Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "LMO Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "LMO Module",
            "description": "LMOs",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Prospect Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Prospect Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "prospect",
            "description": "List Of Prospects",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "approval",
            "description": "Prospect Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "verification",
            "description": "Verify Prospect",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Schedule Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Schedule Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "schedule",
            "description": "Schedule List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Customer Info Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Customer Info Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "telco-customer",
            "description": "Customer Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "customer-approval",
            "description": "Pending For Approval",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "telco-map",
            "description": "Customer Location Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "customer-invoice",
            "description": "Customer Invoice",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "customer-payments",
            "description": "Customer Payments",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "customer-plan",
            "description": "Customer plan",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "customer-usage",
            "description": "Customer Usage",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "customer-interested-product",
            "description": "Customer Interested Products",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset Tracking",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset Tracking",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "employee-attendence",
            "description": "Session Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "user-tracking",
            "description": "Device Tracking",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "task-tracking",
            "description": "Task Tracking",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "user-latest-tracking",
            "description": "Track All Devices",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Client Job",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Client Job",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "all-client-job",
            "description": "Client Job List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Composition Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Composition Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "c-product-list",
            "description": "Raw Material List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "product-composition-list",
            "description": "Formula List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "batch-info-list",
            "description": "Batch Info List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "industry-list",
            "description": "Industry List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Product Display Zone",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Product Display Zone",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "product-display-zone-list",
            "description": "Product Display Zone List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "add-product-display-zone",
            "description": "Add Product Display Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "edit-product-display-zone",
            "description": "Modify Product Display Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "delete-product-display-zone",
            "description": "Delete Product Display Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Banner Zone Controller",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Banner Zone Controller",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-banner-zone",
            "description": "Add Banner Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "banner-zone-list",
            "description": "Banner Zone List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "delete-banner-zone",
            "description": "Delete Banner Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "modify-banner-zone",
            "description": "Modify Banner Zone",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Product Category Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Product Category Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "product-category-list",
            "description": "Product Categories",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Survey Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Survey Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-survey-master",
            "description": "Add Survey Master",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Ecom Admin Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Ecom Admin Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "cart-list",
            "description": "Cart List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "wish-list",
            "description": "Wish List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "order-list",
            "description": "Order List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "packing-not-done",
            "description": "Packing Not Done",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "packing-done",
            "description": "Packing Done",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Job Portal Management",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Job Portal Management",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "country-code-list",
            "description": "Country Codes",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "experience-list",
            "description": "Experience List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "add-education",
            "description": "Add Education",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "education-list",
            "description": "Education List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "industry-list",
            "description": "Industries",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "faq-list",
            "description": "FAQs",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "list-location",
            "description": "Locations",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "list-skill",
            "description": "Skills",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "list-language",
            "description": "Languages",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 10,
            "name": "list-notice-period",
            "description": "Notice Period",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 11,
            "name": "list-job",
            "description": "Jobs",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 12,
            "name": "list-job-title",
            "description": "Job Titles",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 13,
            "name": "add-client-logo",
            "description": "Client Logo",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 14,
            "name": "refCustomer-logo-list",
            "description": "Ref Customer Logo List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 15,
            "name": "testimonial-list",
            "description": "Testimonial List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 16,
            "name": "hackathones-list",
            "description": "Hackathones List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 17,
            "name": "privacy-policy",
            "description": "Privacy Policy",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 18,
            "name": "company-profile-list",
            "description": "Company Profile List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 19,
            "name": "home-job-list",
            "description": "Home Job List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Tender Management",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Tender Management",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "tendor-info-list",
            "description": "List of Tenders",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "add-tendor-info",
            "description": "Create Tender",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "modify-tendor-info",
            "description": "Modify Tender",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "delete-tendor-info",
            "description": "Delete Tender",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "tendor-info-open-list",
            "description": "Open Tenders",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "tendor-applicaiton-list",
            "description": "List of Applicants",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "tendor-allocate",
            "description": "Allocate Tender",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "tendor-allocated-list",
            "description": "Allocated Tenders List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "tendor-filter",
            "description": "Tender Advanced Search",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Tender Ticket Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Tender Ticket Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "tendor-ticket",
            "description": "Create Work Module",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "tendor-ticket-list",
            "description": "List Work Module",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "tendor-ticket-filter-list",
            "description": "Tender Wise Work Module List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Existing Customer Info",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Existing Customer Info",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "ec-list",
            "description": "Existing Customer List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "ec-requests-list",
            "description": "Unverified Customer List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "ec-map",
            "description": "Existing Customer Map",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "ec-to-be-approved-list",
            "description": "To-Be Approved List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Prop Trade",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Prop Trade",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "enquiry-listing-list",
            "description": "Enquiry Listing",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Property Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Property Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "property-list",
            "description": "Property List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "to-be-approve-property",
            "description": "To Be Approve Property",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "filter-property-by-status",
            "description": "Filter Property By Status",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Home Property Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Home Property Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-home-property",
            "description": "Add Home Property",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "home-property-list",
            "description": "Home Property List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Popular Property Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Popular Property Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-popular-property",
            "description": "Add Popular Property",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "popular-property-list",
            "description": "Popular Property List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "delete-popular-property",
            "description": "Delete Popular Property",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Property Type Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Property Type Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-property-type",
            "description": "Add Property Type",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "property-type-list",
            "description": "Property Type List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "edit-property-type",
            "description": "Edit Property Type",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "delete-property-type",
            "description": "Delete Property Type",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Skill Wise Profile Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Skill Wise Profile Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "skill-wise-profile-list",
            "description": "Skill Wise Profile List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Company Schedule List",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Company Schedule List",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "skill-wise-profile-schedule-list",
            "description": "Company Schedule List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "skill-wise-profile-schedule-search",
            "description": "Schedule Search",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Influencer Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Influencer Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "influencer-list",
            "description": "Influencer List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Star Info Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Star Info Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-star-info-controller",
            "description": "AddStarInfoController",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "star-info-controllet-list",
            "description": "StarInfoControlletList",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "modify-star-info-controller",
            "description": "ModifyStarInfoController",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "delete-star-info-controller",
            "description": "DeleteStarInfoController",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Distributor Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Distributor Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "i-distributor-list",
            "description": "Distributors",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Company Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Company Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "company",
            "description": "Company List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Client Docs Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Client Docs Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "client-doc",
            "description": "Client Docs",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "access-privileges-requests",
            "description": "Access Privileges Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "client-doc-filter",
            "description": "Client-doc Filter",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Seva Requests",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Seva Requests",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "ttd-form",
            "description": "Pilgrims Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "ttd-list",
            "description": "Aprove Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Temple Info",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Temple Info",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-temple-info",
            "description": "Define Temple Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "temple-info-list",
            "description": "List of Temples",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "User Quotas",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "User Quotas",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-user-quotas",
            "description": "Add User Quotas",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "user-quotas-list",
            "description": "User Quotas List",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Whatsapp Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Whatsapp Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "create-template",
            "description": "Create Template",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "send-whatsapp-message",
            "description": "Send Whatsapp Message",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Client Config",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Client Config",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "add-new-client",
            "description": "Add New Client",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Project Site Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Project Site Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "cust-loc-wise-exp",
            "description": "Site Expenses",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "cust-loc-wise-exp-total",
            "description": "Date Wise Expenses",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "cust-loc-wise-exp-total-filter",
            "description": "Customer Wise Expenses",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Dealer Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Dealer Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "i-dealer-list",
            "description": "Dealers",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Indent Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Indent Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "indent-info",
            "description": "Indent Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "indent-info-request",
            "description": "Indent Requests",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "indent-info-approve",
            "description": "Approve Indents",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "indent-info-issue",
            "description": "Issue Indents",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "indent-info-verify",
            "description": "Verify Indents",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Reports",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Reports",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "asset-report",
            "description": "Asset Reports",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "inventory-report",
            "description": " Inventory Reports",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Budgetting",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Budgetting",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "asset-budgeting",
            "description": "Asset Budgetting",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset Module",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset Module",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "route-map",
            "description": "Route Map",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "locate-device",
            "description": "Locate Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "network-design",
            "description": "Define Asset Route",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "layer-object",
            "description": "View Routes",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "branch-map",
            "description": "Branch Map",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "object-template",
            "description": "Asset Template",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "asset-list",
            "description": "Manage Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "performance-history",
            "description": "Performance History",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "asset-list-filter",
            "description": "Asset By Template",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 10,
            "name": "repair-info-list",
            "description": "Asset Under Repair",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 11,
            "name": "object-allocation-register",
            "description": "Asset Allocation Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 12,
            "name": "object-allocation-register-group",
            "description": "Asset Allocation Register Group",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 13,
            "name": "maintenance-schedule-list",
            "description": "Maintenance Schedule",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 14,
            "name": "object-type",
            "description": "Asset Type",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 15,
            "name": "object-group",
            "description": "Asset Group",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 16,
            "name": "depreciation-register",
            "description": "Depreciation Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 17,
            "name": "object-allocation-register-history",
            "description": "Asset Alloction History",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 18,
            "name": "asset-bulk",
            "description": "Asset Bulk Upload",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 19,
            "name": "client-doc",
            "description": "Digital Asset Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 20,
            "name": "access-privileges-requests",
            "description": "Request for Access",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 21,
            "name": "client-doc-filter",
            "description": "Search for Digital Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 22,
            "name": "asset-live-monitoring",
            "description": "Asset Live Monitoring",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 23,
            "name": "asset-data-register",
            "description": "Asset Data Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 24,
            "name": "asset-performance",
            "description": "Asset Performance",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 25,
            "name": "asset-audit-info",
            "description": "Audit Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 26,
            "name": "asset-audit-report",
            "description": "Audit Report",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 27,
            "name": "asset-holding",
            "description": "Asset Holding",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 28,
            "name": "template-counts",
            "description": "Asset Counts",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset Allocation",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset Allocation",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "object-allocation-register",
            "description": "Asset Allocation Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "object-allocation-register-history",
            "description": "Allocation History",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "asset-holding",
            "description": "Asset Holding",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Digital Assets",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Digital Assets",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "client-doc",
            "description": " Digital Asset Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "access-privileges-requests",
            "description": "Request for Access",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "client-doc-filter",
            "description": " Search for Digital Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Maintenance & Repair",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Maintenance & Repair",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "repair-info-list",
            "description": " Assets Under Repair",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "maintenance-schedule-list",
            "description": " Maintenance Schedule",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset Monitoring",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset Monitoring",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "performance-history",
            "description": " Asset Health Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "asset-live-monitoring",
            "description": " Asset Live Monitoring",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "asset-data-register",
            "description": " Asset Data Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "asset-performance",
            "description": " Asset Performance",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "faces-register",
            "description": "Register Faces",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset Depreciation",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset Depreciation",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "depreciation-register",
            "description": "Depreciation Register",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Auditing",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Auditing",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "asset-audit-info",
            "description": "Audit Info",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "asset-audit-report",
            "description": "Audit Report",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Budgeting",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Budgeting",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "asset-budgeting",
            "description": "Asset Budgeting",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Asset",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Asset",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "locate-device",
            "description": "Locate Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "object-template",
            "description": "Asset Template",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 3,
            "name": "asset-list",
            "description": "Manage Asset",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 4,
            "name": "asset-list-filter",
            "description": "Asset By Template",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 5,
            "name": "asset-bulk",
            "description": "Asset Bulk Upload",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 6,
            "name": "template-counts",
            "description": "Asset Counts",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 7,
            "name": "asset-compare",
            "description": "Recommendation",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 8,
            "name": "object-transit",
            "description": "Asset Transit",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 9,
            "name": "upload-bulk-asset-map",
            "description": "Asset Location",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  },
  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "roleName": "Tickets & Tasks",
    "level": 0,
    "screenGroupList": [
      {
        "version": 0,
        "isActive": true,
        "description": "string",
        "seqNo": 1,
        "groupName": "Tickets & Tasks",
        "screenPrivilegeList": [
          {
            "seqNo": 1,
            "name": "ticketlist",
            "description": "Ticket",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          },
          {
            "seqNo": 2,
            "name": "tasklist",
            "description": "Task",
            "add": true,
            "view": true,
            "modify": true,
            "delete": true,
            "verify": true,
            "approve": true,
            "issue": true,
            "attach": true,
            "remove": true,
            "originalName": "string",
            "screenPrivilegeScopeList": [
              {
                "controllerName": "string",
                "type": "string",
                "serverPrivilege": "string"
              }
            ]
          }
        ],
        "cid": 0
      }
    ],
    "cid": 0
  }
];
